import ReactDOM from "react-dom/client";
import App from "./App";
import "./i18n";
import "./apm";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(<App />);
